var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.modal = function () {
    return {
        modal: {
            ['x-on:click']: 'click($event, $dispatch)',
        },
        click($event, $dispatch) {
            $dispatch('open-modal');
        },
    }
}